window.initCKEditorEl = (uniqueWindowName, elementIdToReplace, elementToFill = null) => {
    if (!elementToFill) {
        elementToFill = $('#' + elementIdToReplace);
    } else if (typeof elementToFill === 'string') {
        elementToFill = $(elementToFill);
    }

    const functionName = uniqueWindowName + '__ckeditorInit';
    const instanceName = uniqueWindowName + '__ckeditorInstance';
    if (typeof window[functionName] === 'undefined') {
        window[functionName] = function () {
            return CKEDITOR.replace(elementIdToReplace, {
                toolbar: [
                    { name: 'styles', items: ['Format', 'Font', 'FontSize'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Strike', 'Underline', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['Outdent', 'Indent', 'NumberedList', 'BulletedList', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
                    { name: 'insert', items: ['Table', 'HorizontalRule', 'SpecialChar'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] },
                    { name: 'clipboard', items: ['Copy', 'PasteText', 'PasteFromWord', 'Undo', 'Redo'] },
                    { name: 'links', items: ['Link', 'Unlink'] },
                ]
            });
        }
    }
    if (typeof window[instanceName] === 'undefined') {
        window[instanceName] = window[functionName]();
    } else {
        window[instanceName].destroy();
        window[instanceName] = window[functionName]();
    }
    window[instanceName].on('change', function () {
        try {
            elementToFill.val(window[instanceName].getData());
        } catch (e) {}
    });
};
